import { queryKeyFn } from '../../generated/sitContext';
export function getEmployeesQueryData(queryClient) {
    return queryClient.getQueriesData({
        queryKey: queryKeyFn({
            path: '/employees',
            operationId: 'getApiEmployees',
            variables: {},
        }),
    });
}
export function getEmployeeQueryData(queryClient, id) {
    const cachedEmployeesData = getEmployeesQueryData(queryClient);
    for (const [_, employeesResponse] of cachedEmployeesData) {
        if (!employeesResponse?.employees?.length) {
            continue;
        }
        const employee = employeesResponse.employees.find((e) => e.id === id);
        if (employee) {
            return employee;
        }
    }
}
export function setEmployeeOvertimeCalculations(queryClient, { employeeId, companyId, week, }, updatedData) {
    queryClient.setQueriesData({
        queryKey: ['employees', employeeId, 'overtime-calculations'],
        predicate: ({ queryKey }) => {
            if (queryKey.length !== 5)
                return false;
            const weekParam = queryKey[3];
            const variables = queryKey[4];
            return (!!variables &&
                typeof variables === 'object' &&
                variables
                    .companyId === companyId &&
                week === weekParam);
        },
    }, (data) => {
        if (!data)
            return updatedData;
        return {
            ...data,
            ...updatedData,
        };
    });
}
export async function invalidateEmployeeOvertimeCalculations(queryClient, employeeId) {
    await queryClient.invalidateQueries({
        queryKey: ['employees', employeeId, 'overtime-calculations'],
    });
}
export function removeEmployeeOvertimeCalculations(queryClient, employeeId) {
    queryClient.removeQueries({
        queryKey: ['employees', employeeId, 'overtime-calculations'],
    });
}
//# sourceMappingURL=query.js.map